module.exports = __webpack_public_path__ + "static/media/add.08ec3924.svg";